/* eslint-disable no-unused-vars */
const Types = require('../../../../../../jsdoc-types');
const { getNumericValueWithDecimals } = require('../../analyticUtils');
/* eslint-enable no-unused-vars */

const { analyticsEventBus, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/**
 * Subscribe to our analytics events and push the event
 */
function subscribeToAnalyticsEvents() {
  analyticsEventBus.subscribe(ANALYTICS_EVENTS.giftCardAddedToCart, () => {
    pushEvent(
      createCustomEventGA4('product_custom', [
        ['action', 'add'],
        ['item', 'gift_card'],
      ])
    );
  });

  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.giftCardBalanceChecked,
    /**
     * @param {Object} payload - Event payload
     * @param {number} payload.balanceAmount - Numeric balance of the gift card
     * @param {string} payload.balanceCurrencyCode - ISO currency code (e.g. "EUR")
     */
    () => {
      pushEvent(
        createCustomEventGA4('gift_card_balance', [['action', 'continue']])
      );
    }
  );

  analyticsEventBus.subscribe(
    ANALYTICS_EVENTS.giftCardSelected,
    /**
     * Handle that the user have confirmed the selection of a gift card type and
     *  an amount
     * @param {Object} payload - The payload of the event
     * @param {string} payload.type - Gift card design or type
     * @param {Types.AmountModel} payload.amount - Selected amount
     */
    (payload) => {
      pushEvent(
        createCustomEventGA4('gift_card', [
          ['type', payload.type],
          ['item', getNumericValueWithDecimals(payload.amount?.decimalPrice)],
          ['action', 'continue'],
        ])
      );
    }
  );
}

module.exports = {
  subscribeToAnalyticsEvents,
};
